// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/en/translation.json';
import translationUK from './locales/uk/translation.json';
import translationRU from './locales/ru/translation.json';
import translationES from './locales/es/translation.json';
import translationPT from './locales/pt/translation.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationEN },
      uk: { translation: translationUK },
      ru: { translation: translationRU },
      es: { translation: translationES },
      pt: { translation: translationPT },
    },
    lng: localStorage.getItem("i18nextLng") || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
